import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

const MailCard = ({ id, value: defaultValue, handleSave, handleDelete }) => {
  const [value, setValue] = useState(defaultValue);

  return (
    <div
      style={{
        padding: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '0.5rem',
      }}
    >
      <Form.Control
        placeholder="מייל"
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <Button variant="primary" onClick={() => handleSave(id, value)}>
        שמור
      </Button>
      <Button variant="danger" onClick={handleDelete}>
        מחק
      </Button>
    </div>
  );
};

export default MailCard;
